
import { createPopper } from '@popperjs/core';
import hoverintent from 'hoverintent';
import { computed, onBeforeUnmount, onMounted, ref, shallowRef } from '@vue/composition-api';
import { useResizeStore } from '~/store/resize';
interface Props {
  active?: boolean;
  loading?: boolean;
  tips?: boolean;
  type?: 'compare' | 'favorite';
}
const __sfc_main = {};
__sfc_main.props = {
  active: {
    key: "active",
    required: false,
    type: Boolean
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean
  },
  tips: {
    key: "tips",
    required: false,
    type: Boolean,
    default: true
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'compare'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const resizeStore = useResizeStore();
  const isActiveHover = ref(false);
  const initializedHover = ref(false);
  const handler = shallowRef<HTMLDivElement>();
  const root = shallowRef<HTMLDivElement>();
  const contentHover = shallowRef<HTMLDivElement>();
  let toolHover: ReturnType<typeof createPopper> | null;
  let $hoverintent: ReturnType<typeof hoverintent> | null;
  const POPOVER_MODIFIERS = [{
    name: 'offset',
    options: {
      offset: [0, 5]
    }
  }, {
    name: 'preventOverflow',
    options: {
      padding: 20
    }
  }];
  const content = computed(() => {
    if (props.type === 'compare') return props.active ? 'Удалить из сравнения' : 'Добавить в сравнение';else return props.active ? 'Удалить из избранного' : 'Добавить в избранное';
  });
  const showHoverPopover = computed(() => isActiveHover.value && !props.loading && props.tips);
  onMounted(() => {
    if (handler.value) $hoverintent = hoverintent(handler.value, initHoverPopovers, destroyHoverPopovers);
  });
  function initHoverPopovers() {
    if (!resizeStore.isMobile) {
      if (!initializedHover.value && root.value && contentHover.value) {
        toolHover = createPopper(root.value, contentHover.value, {
          placement: 'top',
          modifiers: POPOVER_MODIFIERS
        });
      }
      initializedHover.value = true;
      isActiveHover.value = true;
    }
  }
  onBeforeUnmount(() => {
    if ($hoverintent) $hoverintent.remove();
    destroyHoverPopovers();
  });
  function destroyHoverPopovers() {
    isActiveHover.value = false;
    if (toolHover) {
      toolHover.destroy();
      toolHover = null;
      initializedHover.value = false;
    }
  }
  function handleClickTool() {
    props.active ? emit('remove') : emit('add');
  }
  return {
    handler,
    root,
    contentHover,
    content,
    showHoverPopover,
    handleClickTool
  };
};
export default __sfc_main;
